import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LanguageState {
  locale: string;
  setLocale: (locale: string) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      locale: 'en', // Default to English
      setLocale: (locale: string) => {
        set({ locale });
        // Store in localStorage for React Admin compatibility
        localStorage.setItem('ECommerce_language', locale);
      },
    }),
    {
      name: 'language-storage',
      partialize: (state) => ({ locale: state.locale }),
    }
  )
);

// Initialize from localStorage if available (only in browser)
if (typeof window !== 'undefined') {
  try {
    const storedLanguage = localStorage.getItem('ECommerce_language');
    if (storedLanguage && ['en', 'vi', 'fr'].includes(storedLanguage)) {
      useLanguageStore.getState().setLocale(storedLanguage);
    } else {
      // Ensure default locale is set
      useLanguageStore.getState().setLocale('en');
    }
  } catch (error) {
    console.warn('Failed to initialize language from localStorage:', error);
    // Ensure default locale is set even if localStorage fails
    useLanguageStore.getState().setLocale('en');
  }
}
